import FirestoreDocument from "../../../types/FirestoreDocument";
import FirestoreLifecycle from "../../../types/FirestoreLifecycle";
import { StorageFile } from "../../../types/StorageFile";
import { array, boolean, language, nullable, number, record, string } from "../../../types/_types";

import { articleType } from "../../articles/types/Article";
import { Pipeline } from "../../pipelines/types/Pipeline";

import { DistributionChannelEmailNotification } from "./DistributionChannelEmailNotifcation";

export const DistributionChannel = FirestoreDocument.extend({
	icon: nullable(StorageFile),
	acceptedArticleTypes: array(articleType),
	acceptedDeliveryTypes: array(string()),
	acceptedLanguages: array(language()),
	active: boolean(),
	customXmlTemplate: nullable(string()),
	disableArtifactDeliveryWithoutMetadata: boolean(),
	disablePrices: boolean().default(false),
	distributionPipelineId: nullable(string()),
	emailNotification: nullable(DistributionChannelEmailNotification),
	enabledTemplates: nullable(array(string())),
	excelTemplate: nullable(string()),
	forceDeliveryOfMetadataAndFilesSimultaneously: boolean(false),
	jsonTemplate: nullable(string()),
	maxConcurrentDistributions: number().default(100),
	maxFileDurationInMinutes: nullable(number()),
	name: string(3),
	abbreviation: string().default(""),
	onixTemplate: nullable(string()),
	pipelines: record(string(), Pipeline.partial()).default({}),
	preventTakedown: boolean(false),
	releaseDateGracePeriod: number().default(0),
	requiredMetadataKeys: array(string()),
	subChannels: array(record(string(), string())),
	supportsAnnouncementDate: boolean().default(false),
	supportsTakedownDate: boolean().default(false),
	takedownDateGracePeriod: number().default(0),
}).merge(FirestoreLifecycle);
